import React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { NavLink } from 'react-router-dom';
import { Autoplay } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import Image1 from "../assets/Image4.jpeg";
import Image3 from "../assets/Image2.jpeg";
import Image2 from "../assets/cryoFacial.png";
import { Swiper, SwiperSlide } from 'swiper/react';
import Image4 from "../assets/Gallery-Photos/cryo-slimming.webp";
import Image7 from "../assets/Gallery-Photos/couple-maassage.png";
import Image6 from "../assets/Gallery-Photos/Therapy-adiocialy-massage.jpg";



const PhotoGallery = () => {
  const { t } = useTranslation();

  const images = [
    { src: Image1, title: t('localizedCryotherapy') },
    { src: Image2, title: t('cryoMassageTitle') },
    { src: Image3, title:  t('cryotherapyFacial')},
    { src: Image4, title: t('cryoSlimming') },
    // { src: Image5, title: t('faceMassage') },
    { src: Image6, title: t('therapyAddictionalMassage') },
    { src: Image7, title: t('coupleMassage') },
  ];
  

  return (
    <div className='mt-16'>
      {/* <h1 className='text-4xl font-semibold text-center mb-10 font-Merriweather'>{t('photoGallery')}</h1> */}

    <div>
    <Swiper
        modules={[Autoplay]}
            loop={true}
            slidesPerView={1}
            spaceBetween={0}
            breakpoints={{
              640: { slidesPerView: 3, },
              1024: { slidesPerView: 5 },
            }}
            centeredSlides={false}
            autoplay={{ delay: 1000, disableOnInteraction: false }}
            className="mySwiper"
          >
            {images.map((item, i) => (
              <SwiperSlide key={i}>
              <NavLink to="/services">
            <div className='relative group'>
              <div className='h-80'>
                <img 
                  src={item.src} 
                  alt={`Gallery ${i + 1}`} 
                  className="curson-pointer transition-transform duration-500 ease-in-out group-hover:scale-110 h-full object-cover w-full" 
                  loading="lazy"
                  fetchPriority={i < 3 ? "high" : "low"}
                  decoding="async"
                />
                </div>
                <div className="absolute bg-black inset-0 top-0 opacity-10 group-hover:opacity-0 transition-opacity duration-500"></div>

                <div className='absolute top-0 z-40 h-full flex justify-center items-center w-full'>
                  <h1 className='capitalize p-2 text-2xl font-semibold  text-white text-center'>{item.title}</h1>
                </div>
            </div>
            </NavLink>
            </SwiperSlide>
           ))}
      </Swiper>
    </div>
    </div>
  )
}

export default PhotoGallery
